(() => {
  const root = document.querySelector('[data-pdp-root]');
  if (!root) return;

  const jsonEl = root.querySelector('[data-pdp-json]');
  let pdpData = { colorOptionIndex: -1, variants: [], media: [] };
  try {
    pdpData = JSON.parse(jsonEl.textContent);
  } catch (err) {
    /* leave defaults */
  }

  const gallery = root.querySelector('[data-pdp-gallery]');
  const stage = root.querySelector('[data-pdp-stage]');
  const slides = Array.from(root.querySelectorAll('[data-pdp-slide]'));
  const thumbs = Array.from(root.querySelectorAll('[data-pdp-thumb]'));
  const prevBtn = root.querySelector('[data-pdp-prev]');
  const nextBtn = root.querySelector('[data-pdp-next]');
  const counter = root.querySelector('[data-pdp-counter]');

  let currentIndex = Math.max(
    0,
    slides.findIndex((s) => s.hasAttribute('data-active'))
  );

  function setActiveIndex(index) {
    if (!slides.length) return;
    const total = slides.length;
    currentIndex = ((index % total) + total) % total;

    slides.forEach((slide, i) => {
      if (i === currentIndex) {
        slide.setAttribute('data-active', '');
      } else {
        slide.removeAttribute('data-active');
      }
    });
    thumbs.forEach((thumb, i) => {
      const active = i === currentIndex;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (counter) counter.textContent = `${currentIndex + 1} / ${slides.length}`;
    updateLightboxImage();
  }

  function setActiveByMediaId(mediaId) {
    if (!mediaId) return;
    const index = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
    if (index > -1) setActiveIndex(index);
  }

  prevBtn?.addEventListener('click', () => setActiveIndex(currentIndex - 1));
  nextBtn?.addEventListener('click', () => setActiveIndex(currentIndex + 1));
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => setActiveIndex(Number(thumb.dataset.index)));
  });

  if (stage) {
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') setActiveIndex(currentIndex - 1);
      if (e.key === 'ArrowRight') setActiveIndex(currentIndex + 1);
    });

    let touchStartX = 0;
    stage.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        setActiveIndex(currentIndex + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
  }

  /* ---------- Lightbox / zoom ---------- */
  let lightbox = null;
  function buildLightbox() {
    lightbox = document.createElement('div');
    lightbox.className = 'pdp-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML = `
      <div class="pdp-lightbox__overlay" data-pdp-lightbox-close></div>
      <button type="button" class="pdp-lightbox__close" data-pdp-lightbox-close aria-label="Close">×</button>
      <button type="button" class="pdp-lightbox__arrow pdp-lightbox__arrow--prev" data-pdp-lightbox-prev aria-label="Previous image">‹</button>
      <img class="pdp-lightbox__image" data-pdp-lightbox-image alt="">
      <button type="button" class="pdp-lightbox__arrow pdp-lightbox__arrow--next" data-pdp-lightbox-next aria-label="Next image">›</button>
    `;
    document.body.appendChild(lightbox);

    lightbox.querySelectorAll('[data-pdp-lightbox-close]').forEach((el) => {
      el.addEventListener('click', closeLightbox);
    });
    lightbox.querySelector('[data-pdp-lightbox-prev]').addEventListener('click', () => setActiveIndex(currentIndex - 1));
    lightbox.querySelector('[data-pdp-lightbox-next]').addEventListener('click', () => setActiveIndex(currentIndex + 1));
  }

  function updateLightboxImage() {
    if (!lightbox || lightbox.getAttribute('aria-hidden') === 'true') return;
    const slide = slides[currentIndex];
    const bigSrc = slide?.querySelector('img')?.currentSrc || slide?.querySelector('img')?.src;
    const img = lightbox.querySelector('[data-pdp-lightbox-image]');
    if (img && bigSrc) img.src = bigSrc;
  }

  let lastFocused = null;
  function openLightbox() {
    if (!lightbox) buildLightbox();
    updateLightboxImage();
    lastFocused = document.activeElement;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pdp-lightbox-open');
    lightbox.querySelector('[data-pdp-lightbox-close]').focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pdp-lightbox-open');
    lastFocused?.focus();
  }

  root.querySelectorAll('[data-pdp-zoom-open]').forEach((btn) => {
    btn.addEventListener('click', openLightbox);
  });

  document.addEventListener('keydown', (e) => {
    if (!lightbox || lightbox.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') setActiveIndex(currentIndex - 1);
    if (e.key === 'ArrowRight') setActiveIndex(currentIndex + 1);
  });

  /* ---------- Variant picker ---------- */
  const form = root.querySelector('.pdp-form');
  const variantIdInput = root.querySelector('[data-pdp-variant-id]');
  const priceCurrentEl = root.querySelector('[data-pdp-price-current]');
  const priceCompareEl = root.querySelector('[data-pdp-price-compare]');
  const addBtn = root.querySelector('[data-pdp-add-to-bag]');
  const addLabel = root.querySelector('[data-pdp-add-label]');
  const stickyBar = document.querySelector('[data-pdp-sticky-bar]');
  const stickyPrice = stickyBar?.querySelector('[data-pdp-sticky-price]');
  const stickyAddBtn = stickyBar?.querySelector('[data-pdp-sticky-add]');

  const currency = root.dataset.currency || 'USD';
  function formatMoney(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency });
    } catch (err) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  function currentSelection() {
    const groups = root.querySelectorAll('[data-pdp-option]');
    return Array.from(groups).map((group) => {
      const checked = group.querySelector('[data-pdp-option-input]:checked');
      return checked ? checked.value : null;
    });
  }

  function findMatchingVariant(selection) {
    return pdpData.variants.find((v) => v.options.every((opt, i) => opt === selection[i]));
  }

  function applyVariant(variant) {
    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'UNAVAILABLE';
      if (stickyAddBtn) stickyAddBtn.disabled = true;
      return;
    }
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceCurrentEl) priceCurrentEl.textContent = formatMoney(variant.price);
    if (priceCompareEl) {
      if (variant.compareAtPrice > variant.price) {
        priceCompareEl.textContent = formatMoney(variant.compareAtPrice);
        priceCompareEl.hidden = false;
      } else {
        priceCompareEl.hidden = true;
      }
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    const available = variant.available;
    if (addBtn) addBtn.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'ADD TO BAG' : 'SOLD OUT';
    if (stickyAddBtn) {
      stickyAddBtn.disabled = !available;
      stickyAddBtn.textContent = available ? 'ADD TO BAG' : 'SOLD OUT';
    }

    if (variant.featuredMediaId) setActiveByMediaId(variant.featuredMediaId);
  }

  function onOptionChange() {
    const selection = currentSelection();
    const variant = findMatchingVariant(selection);
    applyVariant(variant);

    const colorIndex = pdpData.colorOptionIndex;
    if (colorIndex > -1 && selection[colorIndex]) {
      const label = root.querySelector(
        `[data-pdp-option][data-option-index="${colorIndex}"] [data-pdp-option-value]`
      );
      if (label) label.textContent = selection[colorIndex];
    }
  }

  root.querySelectorAll('[data-pdp-option-input]').forEach((input) => {
    input.addEventListener('change', onOptionChange);
  });

  /* Color story section (elsewhere on the page) selects the same variant option */
  document.querySelectorAll('[data-pdp-color-select]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const color = btn.dataset.color;
      const colorIndex = pdpData.colorOptionIndex;
      if (colorIndex < 0) return;
      const input = root.querySelector(
        `[data-pdp-option][data-option-index="${colorIndex}"] [data-pdp-option-input][value="${CSS.escape(color)}"]`
      );
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        gallery?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  /* ---------- Sticky mobile Add to Bag ---------- */
  if (addBtn && stickyBar && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      },
      { threshold: 0 }
    );
    io.observe(addBtn);
  }

  stickyAddBtn?.addEventListener('click', () => {
    if (form?.requestSubmit) {
      form.requestSubmit();
    } else {
      form?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  });
})();
